import storage from "./../storage";

interface Form {
  key: string;
  campaign_name: string;
  cvos_login: string;
  fields: object;
  kind: string;
  place_id: string;
  place_name: string;
  percentage: number;
  status: string;
  submitted_at: string;
  task_id: string;
}

interface SubField {
  kind: string;
  value: any;
}

interface SubForm {
  [key: string]: SubField;
}

interface ProcessingForms {
  forms: Array<Form>;
  init: () => Promise<void>;
}

const formSyncStatusChannel = new BroadcastChannel("form-sync-status-channel");

async function getProcessingForms(): Promise<Form[]> {
  const forms: Array<Form> = [];
  await storage.iterate({ storeName: "forms" }, (value) => {
    if (value !== null && typeof value === "object") {
      const form = value as Form;
      if (["processing", "pending"].includes(form.status)) {
        let uploadedImageCount = 0;
        let toUploadImageCount = 0;
        for (const [_key, field] of Object.entries(form.fields)) {
          if (field.kind === "uploader") {
            uploadedImageCount = uploadedImageCount + field.value.uploaded.length;
            toUploadImageCount = toUploadImageCount + field.value.to_upload.length;
          }
          if (field.kind === "form") {
            const subForms: Array<SubForm> = field.value;
            for (const [_key, subForm] of Object.entries(subForms)) {
              for (const [_key, subField] of Object.entries(subForm)) {
                if (subField.kind === "uploader") {
                  uploadedImageCount = uploadedImageCount + subField.value.uploaded.length;
                  toUploadImageCount = toUploadImageCount + subField.value.to_upload.length;
                }
              }
            }
          }
        }

        if (toUploadImageCount === 0) {
          form.percentage = 100;
        } else {
          form.percentage = Math.round(
            (uploadedImageCount / (toUploadImageCount + uploadedImageCount)) * 100,
          );
        }
      }

      forms.push(form);
    }
  });
  return forms.sort((a, b) => Date.parse(b.submitted_at) - Date.parse(a.submitted_at));
}

async function refreshProcessingForms() {
  const forms = await getProcessingForms();
  const e = new CustomEvent("forms-load", { detail: { forms: forms } });
  window.dispatchEvent(e);
}

function postSubmitMessage(key: string) {
  if (window.navigator.serviceWorker.controller) {
    window.navigator.serviceWorker.controller.postMessage(
      JSON.stringify({
        type: "submit_form",
        formKey: key,
      }),
    );
  }
}

function alpineData() {
  return {
    forms: [],
    async init() {
      this.forms = await getProcessingForms();

      formSyncStatusChannel.onmessage = async (event) => {
        if (event.data === "update") {
          refreshProcessingForms();
        }
      };

      const el = document.getElementById("processing-forms-list");

      if (el) {
        el.addEventListener("process_form", async (event: Event) => {
          const task_id = (<CustomEvent>event).detail.task_id;
          const form = (await storage.getItem(`task-${task_id}`, { storeName: "forms" })) as Form;

          if (typeof form === "object") {
            const key = `task-${task_id}`;
            form.status = "pending";
            form.key = key;
            await storage.setItem(form, { storeName: "forms" });
            await refreshProcessingForms();
            postSubmitMessage(key);
          }
        });
      }
    },
  } as ProcessingForms;
}

export default alpineData;

export { getProcessingForms };
